import React, { useState } from 'react'
import { useChatHistory } from '../../contexts/ChatHistoryContext'
import ChatSkeleton from './ChatSkeleton'
import './ChatHistorySidebar.scss'

const ChatHistorySidebar = ({ onChatSelect }) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [chatToDelete, setChatToDelete] = useState(null)
    
    const {
        conversations,
        activeChatId,
        switchChat,
        deleteChat,
        createNewChat,
        isLoadingConversations
    } = useChatHistory()

    console.log('ChatHistorySidebar - conversations:', conversations) // Debug log

    const handleChatClick = (id) => {
        switchChat(id)
        if (onChatSelect) onChatSelect(id)
    }

    const handleDeleteClick = (chat, e) => {
        e.stopPropagation()
        setChatToDelete(chat)
        setShowDeleteModal(true)
    }

    const confirmDelete = async () => {
        if (chatToDelete) {
            await deleteChat(chatToDelete.id)
            setShowDeleteModal(false)
            setChatToDelete(null)
        }
    }

    const cancelDelete = () => {
        setShowDeleteModal(false)
        setChatToDelete(null)
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString)
        const now = new Date()
        const diff = now - date

        if (diff < 86400000 && now.getDate() === date.getDate()) {
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        }
        return date.toLocaleDateString([], { month: 'short', day: 'numeric' })
    }

    return (
        <div className="chat-history-sidebar">
            <div className="chat-history-header">
                <button className="new-chat-btn" onClick={() => createNewChat()}>
                    <i className="uil uil-plus"></i>
                    <span>New Chat</span>
                </button>
            </div>

            <div className="chat-history-list">
                {isLoadingConversations ? (
                    // Show skeleton items while loading
                    Array.from({ length: 3 }).map((_, index) => (
                        <ChatSkeleton key={index} />
                    ))
                ) : conversations.length === 0 ? (
                    <div className="empty-state">
                        No conversations yet.
                    </div>
                ) : (
                    conversations.map((chat) => (
                        <div
                            key={chat.id}
                            className={`chat-item ${activeChatId === chat.id ? 'active' : ''}`}
                            onClick={() => handleChatClick(chat.id)}
                        >
                            <i className="uil uil-comment-alt-notes chat-icon"></i>
                            <div className="chat-info">
                                <span className="chat-title">{chat.title}</span>
                                <span className="chat-timestamp">{formatDate(chat.updatedAt)}</span>
                            </div>
                            <button
                                className="delete-btn"
                                onClick={(e) => handleDeleteClick(chat, e)}
                            >
                                <i className="uil uil-trash-alt"></i>
                            </button>
                        </div>
                    ))
                )}
            </div>
            
            {showDeleteModal && (
                <div className="delete-modal-overlay">
                    <div className="delete-modal">
                        <div className="delete-modal-content">
                            <h3>Delete Chat</h3>
                            <p>Are you sure you want to delete "{chatToDelete?.title}"? This action cannot be undone.</p>
                            <div className="delete-modal-actions">
                                <button className="cancel-btn" onClick={cancelDelete}>
                                    Cancel
                                </button>
                                <button className="confirm-delete-btn" onClick={confirmDelete}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ChatHistorySidebar
